<ol class="breadcrumb mb-0 bg-white">
  <li class="breadcrumb-item active d-flex align-items-center" *ngFor="let data of breadcrumbs">
    <a routerLink="{{ data.link }}" [ngClass]="{ 'text-black': isCurrentRoute(data.link) }" class="mx-4">{{ data.name
      }}</a>
  </li>
</ol>